export const faqs = [
  {
    id: "faq-1",
    question: "网爆吃瓜上的表情包、梗图可以随意使用吗？",
    answer:
      "站内标注为「自取」的内容都可以保存并用于日常聊天与社交分享。用于商业用途前，建议先在「关于我们」页面提交投稿/联系表单确认，我们会逐条回复。",
  },
  {
    id: "faq-2",
    question: "内容多久更新一次？",
    answer:
      "每天 08:00、14:00、21:00 各上新一批内容，重大热梗出现时会临时加更。段子与神回复更新频率最高，二创视频通常集中在晚间上线。",
  },
  {
    id: "faq-3",
    question: "我可以把自己做的表情包或二创视频投稿过来吗？",
    answer:
      "当然可以。在「关于我们」页面填写投稿表单，注明内容和联系方式即可。被采纳后我们会标注作者署名，并在对应频道优先展示。",
  },
  {
    id: "faq-4",
    question: "为什么有些内容只有文字没有配图？",
    answer:
      "神回复频道以文字为主，因为保留原始对话节奏更容易还原笑点；表情包与梗图频道则全部配有可保存的图片，按频道浏览即可。",
  },
  {
    id: "faq-5",
    question: "评论区的「神回复」是怎么筛选的？",
    answer:
      "我们主要看三个维度：点赞速度、转发次数、以及被二次引用的频率。每周会整理一次热评榜单，长期保持高质量的账号会出现在「评论区的课代表」推荐里。",
  },
  {
    id: "faq-6",
    question: "站内内容会涉及真实人物或个人隐私吗？",
    answer:
      "不会。我们只做情绪与生活场景的娱乐化表达，不指向具体个人，也不会收录涉及隐私、纠纷或未经证实的信息。内容原则详见「关于我们」页面。",
  },
  {
    id: "faq-7",
    question: "手机上浏览体验和电脑一样吗？",
    answer:
      "页面已经做了完整适配，手机端会自动收起为单列布局，导航需点击右上角按钮展开。二创视频在小屏幕上默认静音，点击后才会播放声音。",
  },
  {
    id: "faq-8",
    question: "内容有版权问题怎么联系你们？",
    answer:
      "请通过「关于我们」页面的联系表单说明情况并留下联系方式，我们会在收到后尽快核实处理。涉及版权的内容会优先下架。",
  },
];